/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Form } from 'react-bootstrap';
import useProductFields from '../ProductFields/productFields';
import SelectItemType from '../SelectItemType';
import ActionErrorInformation from '../../../API/ActionErrorInformation';
import CreateForm from '../../Forms/CreateForm';
import ExtraFields from '../ExtraFields';
import FormSubmitPortal from '../../Forms/builders/FormSubmitPortal';
import IconButton from '../../UI/IconButton/IconButton.tsx';
import { Carat } from '../../UI/Icons/Icons';
import LBOffCanvas from '../../UI/LBOffCanvas';

function CreateProductModal() {
  const {
    submitting,
    fields,
    formik,
    itemType,
    setItemType,
    setValue,
    profitType,
  } = useProductFields({ productId: null, products: null, modal: true });
  return !itemType ? (
    <LBOffCanvas.Wrapper>
      <LBOffCanvas.Left>
        <LBOffCanvas.Header>Select item type</LBOffCanvas.Header>
        <SelectItemType
          setValue={setValue}
          setItemType={setItemType}
          narrow
          modal
        />
      </LBOffCanvas.Left>
    </LBOffCanvas.Wrapper>
  ) : (
    <LBOffCanvas.Wrapper>
      <LBOffCanvas.Left>
        <LBOffCanvas.Header>Create {itemType}</LBOffCanvas.Header>
        <ActionErrorInformation />
        <Form
          className="mt-2 flex__form-wrapper px-2 p-md-0"
          noValidate
          onSubmit={formik.handleSubmit}
          id="modal-new-prod-or-serv"
        >
          <CreateForm structure={[fields[0]]} {...formik} />
          <ExtraFields
            structure={fields[1]}
            {...formik}
            profitType={profitType}
            narrow
          />

          <FormSubmitPortal portalId="offcanvas-action-group-left">
            <div className="d-flex align-items-center gap-3">
              <IconButton
                text="Next"
                type="submit"
                form="modal-new-prod-or-serv"
                alignText="left"
                color="primary"
                outline={false}
                disabled={submitting || (!formik.isValid && !formik.dirty)}
              >
                <Carat />
              </IconButton>
            </div>
          </FormSubmitPortal>
        </Form>
      </LBOffCanvas.Left>
    </LBOffCanvas.Wrapper>
  );
}

export default CreateProductModal;
